import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Pagination from "react-js-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Clinics/pagination.css";
import { useTranslation } from 'react-i18next';
import { formatDateString } from '../../../utils/dateUtils';
import { APIURL, TZ } from "../../../Global";
import Modal from "react-bootstrap/Modal";
import { useAlert } from "react-alert";

function VendorLiabilities() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const alert = useAlert
    const [selected, setSelected] = useState("all");
    const [loading, setLoading] = useState(false);
    const [liabilities, setLiabilities] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);
    const [hospitalIdSearch, setHospitalIdSearch] = useState("");
    const [hospitalNameSearch, setHospitalNameSearch] = useState("");
    const [sort, setSort] = useState("");
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [selectedInvoiceImage, setSelectedInvoiceImage] = useState("");
    const [loadingInvoice, setLoadingInvoice] = useState(false);

    useEffect(() => {
        fetchLiabilities();
    }, [selected, currentPage, hospitalIdSearch, hospitalNameSearch, sort]);

    const fetchLiabilities = () => {
        setLoading(true);
        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString.replace(/["]+/g, "");

        const paymentStatus = selected === "paid" ? "paid" : "";
        const sortParam = sort ? `&sort=${sort}` : "";
        const hospitalIdParam = hospitalIdSearch ? `&hospital_id=${hospitalIdSearch}` : "";
        const hospitalNameParam = hospitalNameSearch ? `&hospital_name=${hospitalNameSearch}` : "";
        const paymentStatusParam = paymentStatus ? `&payment_status=${paymentStatus}` : "";

        const url = `${APIURL}/api/v1/staff/vendor-liability/?per_page=${perPage}&page=${currentPage}&${TZ}${sortParam}${hospitalIdParam}${hospitalNameParam}${paymentStatusParam}`;

        axios
            .get(url, {
                headers: { Authorization: "Token " + token },
            })
            .then((res) => {
                if (res.data.status === "success") {
                    setLiabilities(res.data.message || []);
                    setTotalRecords(res.data.total_records || 0);
                    setTotalPages(res.data.total_pages || 0);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching liabilities:", err);
                setLoading(false);
            });
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount);
    };

    const handleInvoiceClick = async (billImageUrl) => {
        if (!billImageUrl) {
            alert.error(t('liabilities.noInvoiceImage'));
            return;
        }
        const userTokenString = sessionStorage.getItem("header_alegra");
        const userToken = userTokenString ? userTokenString.replace(/["]+/g, "") : "";
        if (!userToken) {
            alert.error(t('liabilities.loginAlegra'));
            return;
        }
        setLoadingInvoice(true);
        setShowInvoiceModal(true);

        try {

            const jsonResponse = await axios.get(billImageUrl, {
                headers: {
                    Authorization: userToken,
                },
            });

            if (jsonResponse?.data?.pdf && typeof jsonResponse.data.pdf === "string" && jsonResponse.data.pdf.startsWith("http")) {
                setSelectedInvoiceImage(jsonResponse.data.pdf);
                return;
            }

            const blobResponse = await axios.get(billImageUrl, {
                headers: {
                    Authorization: userToken,
                },
                responseType: "blob",
            });

            const contentType = blobResponse.headers["content-type"] || "application/pdf";
            const blob = new Blob([blobResponse.data], { type: contentType });
            const blobUrl = URL.createObjectURL(blob);

            setSelectedInvoiceImage(blobUrl);
        } catch (err) {
            console.error("Error fetching invoice from Alegra:", err);
            setSelectedInvoiceImage(billImageUrl);
        } finally {
            setLoadingInvoice(false);
        }
    };

    const handleCloseModal = () => {
        setShowInvoiceModal(false);

        if (selectedInvoiceImage && selectedInvoiceImage.startsWith("blob:")) {
            try {
                URL.revokeObjectURL(selectedInvoiceImage);
            } catch (e) {
                console.warn("Failed to revoke object URL", e);
            }
        }

        setSelectedInvoiceImage("");
    };

    const renderLiabilityRow = (data) => {
        const isPaid = data.payment_status === "paid";
        const displayAmount = selected === "paid" ? data.paid_amount : data.liability;

        return (
            <div
                className="row"
                key={data.id}
                style={{
                    fontSize: "13px",
                    textAlign: "left",
                    borderLeft: "0.4px solid #5f5e5e7a",
                    borderBottom: "0.4px solid #5f5e5e7a",
                    borderRight: "0.4px solid #5f5e5e7a",
                    boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)",
                    marginBottom: "0.5%",
                }}
            >
                <div
                    style={{
                        backgroundColor: "#40E0D036",
                        padding: "1%",
                        borderRight: "0.4px solid #5f5e5e7a",
                        fontSize: "10px",
                        fontWeight: "bold",
                    }}
                    className="col-1"
                >
                    {data.hospital_id}
                </div>
                <div
                    title={data.hospital_name}
                    style={{
                        backgroundColor: "#40E0D036",
                        padding: "1%",
                        borderRight: "0.4px solid #5f5e5e7a",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textTransform: "capitalize",
                        textOverflow: "ellipsis",
                    }}
                    className="col-2"
                >
                    {data.hospital_name}
                </div>
                <div style={{ padding: "1%", borderRight: "0.4px solid #5f5e5e7a" }} className="col-2">
                    {data.item_name}
                </div>
                <div style={{ padding: "1%", fontWeight: "bold", borderRight: "0.4px solid #5f5e5e7a" }} className="col-2">
                    {formatCurrency(displayAmount)}
                </div>
                <div style={{ padding: "1%", borderRight: "0.4px solid #5f5e5e7a" }} className={selected === "paid" ? "col-1" : "col-2"}>
                    {formatDateString(data.bill_generated_date)}
                </div>
                <div style={{ padding: "1%", borderRight: "0.4px solid #5f5e5e7a" }} className={selected === "paid" ? "col-1" : "col-2"}>
                    {formatDateString(data.renewal_date)}
                </div>
                <div style={{ padding: "1%", borderRight: selected === "paid" ? "0.4px solid #5f5e5e7a" : "none" }} className="col-1">
                    <span
                        style={{
                            padding: "4px 8px",
                            borderRadius: "4px",
                            fontSize: "11px",
                            fontWeight: "bold",
                            backgroundColor: isPaid ? "#d4edda" : "#fff3cd",
                            color: isPaid ? "#155724" : "#856404",
                        }}
                    >
                        {t(`liabilities.statusValues.${data.payment_status}`)}
                    </span>
                </div>
                {selected === "paid" && data?.bill_image && (
                    <div style={{ padding: "1%", display: "flex", justifyContent: "center" }} className="col-2">
                        <button
                            onClick={() => handleInvoiceClick(data.bill_image)}
                            style={{
                                padding: "6px 12px",
                                backgroundColor: "#01C9C9",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: "bold",
                            }}
                        >
                            {t('liabilities.invoice')}
                        </button>
                    </div>
                )}
            </div>
        );
    };

    const display = liabilities.length > 0 ? liabilities.map(renderLiabilityRow) : null;

    return (
        <div className="row" style={{ marginTop: "1%", width: "100%", minHeight: "71vh" }}>
            <div className="col-3">
                <h5 style={{ color: "#5f5e5f", paddingLeft: "2%" }}>
                    {t('liabilities.title')}
                </h5>
                <div className="det-div" style={{ padding: "1%" }}>
                    <button
                        className={selected === "all" ? "patientRecbutton1" : "patientRecbutton"}
                        style={{ width: "100%" }}
                        onClick={() => {
                            setSelected("all");
                            setCurrentPage(1);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" />
                        </svg>
                        {t('liabilities.all')}
                    </button>

                    <button
                        className={selected === "paid" ? "patientRecbutton1" : "patientRecbutton"}
                        style={{ width: "100%" }}
                        onClick={() => {
                            setSelected("paid");
                            setCurrentPage(1);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z" />
                        </svg>
                        {t('liabilities.paid')}
                    </button>
                </div>
            </div>

            <div className="col-9" style={{ minHeight: "71vh" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <div className="search-div">
                                <input
                                    type="text"
                                    className="search-clinics"
                                    placeholder={t('liabilities.searchID')}
                                    value={hospitalIdSearch}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setHospitalIdSearch(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="search-div">
                                <input
                                    type="text"
                                    className="search-clinics"
                                    placeholder={t('liabilities.searchByName')}
                                    value={hospitalNameSearch}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setHospitalNameSearch(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <br />

                <div style={{ margin: "auto" }}>
                    <div className="container">
                        <div className="test-reports-display-list">
                            {display ? (
                                <>
                                    <div
                                        className="row"
                                        style={{
                                            backgroundColor: "#01C9C9",
                                            color: "white",
                                            textAlign: "left",
                                            padding: "1% 0",
                                            borderRadius: "5px 5px 0px 0px",
                                            boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)",
                                            marginBottom: "0.5%",
                                            fontSize: "12px",
                                        }}
                                    >
                                        <div className="col-1">
                                            <b>{t('liabilities.id')}</b>
                                        </div>
                                        <div className="col-2">
                                            <b>{t('liabilities.vendor')}</b>
                                        </div>
                                        <div className="col-2">
                                            <b>{t('liabilities.itemName')}</b>
                                        </div>
                                        <div className="col-2">
                                            <b>{selected === "paid" ? t('liabilities.paidAmount') : t('liabilities.liability')}</b>
                                        </div>
                                        <div className={selected === "paid" ? "col-1" : "col-2"}>
                                            <b>{t('liabilities.billDate')}</b>
                                        </div>
                                        <div className={selected === "paid" ? "col-1" : "col-2"}>
                                            <b>{t('liabilities.renewalDate')}</b>
                                        </div>
                                        <div className="col-1">
                                            <b>{t('liabilities.status')}</b>
                                        </div>
                                        {selected === "paid" && (
                                            <div className="col-2">
                                                <b></b>
                                            </div>
                                        )}
                                    </div>
                                    {display}
                                </>
                            ) : (
                                <div style={{ fontSize: "20px", height: "200px", padding: "10%" }}>
                                    {!loading && (
                                        <h5>
                                            {selected === "all"
                                                ? t('liabilities.noLiabilities')
                                                : t('liabilities.noPaidLiabilities')}
                                        </h5>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {totalPages > 1 && (
                    <div className="pagn pagn-small">
                        <br />
                        <br />
                        <br />
                        <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={perPage}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={totalPages}
                            onChange={handlePageChange}
                            disabledClass="disabled-class"
                        />
                    </div>
                )}
            </div>

            <Modal show={showInvoiceModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('liabilities.invoice')}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ textAlign: "center", minHeight: "400px", padding: 0 }}>
                    {loadingInvoice ? (
                        <div style={{ padding: "50px" }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">{t('liabilities.loading')}</span>
                            </div>
                        </div>
                    ) : selectedInvoiceImage ? (
                        <iframe
                            src={selectedInvoiceImage}
                            title="Invoice"
                            style={{ width: "100%", height: "70vh", border: "none" }}
                        />
                    ) : (
                        <p style={{ padding: "50px" }}>{t('liabilities.noInvoiceImage')}</p>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default VendorLiabilities;